module.exports = __webpack_public_path__ + "static/media/2244.510606e2.jpg";